/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Preview_StudentInputs */

const da_forside_preview_student = /** @type {(inputs: Forside_Preview_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elev 2`)
};

/** @type {(inputs: Forside_Preview_StudentInputs) => LocalizedString} */
const en_forside_preview_student = da_forside_preview_student;

/**

* @param {Forside_Preview_StudentInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_preview_student = /** @type {((inputs?: Forside_Preview_StudentInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Preview_StudentInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_preview_student(inputs)
	return /** @type {LocalizedString} */ ("Elev 2")
});